import React, { useEffect, useState } from "react";
import { DrawerNavigation } from "@tumomento/ui";
import { classNamesList, goToWizardQuote } from "@/utils/components";
import useNavbarLogic from "./useNavbarLogic";
import "./Navbar.scss";
import { Location } from "@/interfaces/Location";
import { Breadcrumb } from "../Breadcrumb";
import { getImagesPath } from "@/utils/statics";
import { Link } from "gatsby";
import { SearchOption } from "@/components/business/SearchOption";

export const Navbar = ({
  location,
  showAll = false,
  showBreadcrumbs = false,
}: {
  location?: Location;
  showAll?: boolean;
  showBreadcrumbs?: boolean;
}) => {
  const [activeSearch, setActiveSearch] = useState(false);
  const {
    isMobile,
    NavbarMenuDesktop,
    NavbarMenuMobile,
    openDrawer,
    setOpenDrawer,
    showCTAButton,
    isFixedActive,
    setIsFixedActive,
  } = useNavbarLogic();

  useEffect(() => {
    if (showAll) {
      setIsFixedActive(true);
    }
  }, [showAll]);

  const breadcrumbNav = (
    <nav
      className={classNamesList(
        `Navbar ${!showCTAButton && "-active"}`,
        "w100 flex align-center justify-between px-4"
      )}
    >
      {location && (
        <Breadcrumb location={location} invertColor={showCTAButton} />
      )}
    </nav>
  );

  const mainNav = (
    <nav
      className={classNamesList(
        `Navbar ${!showCTAButton && !isFixedActive && "-active"}`,
        "w100 flex align-center justify-between px-4"
      )}
    >
      {!activeSearch && (
        <>
          <Link to={isMobile ? "/blog" : "/"} className="NavbarLogo">
            <span
              className="showMobile titleblog"
              style={isFixedActive || showCTAButton ? { color: "#18C9B4" } : {}}
            >
              El blog
            </span>
            <img
              className="showDesktop"
              src={getImagesPath(
                isFixedActive || showCTAButton
                  ? "logo-momento.svg"
                  : "logo-momento-green.svg"
              )}
              height={16}
              width={144}
              alt="Momento"
            />
          </Link>
          <a
            href="/"
            className={`imago${
              isFixedActive || showCTAButton ? "-invert" : ""
            }`}
          >
            <img src={getImagesPath("imago-momento.svg")} alt="momento" />
          </a>
        </>
      )}

      <div className={`showMobile ${!activeSearch ? "" : "w100"}`}>
        <div className="flex row g-1">
          <SearchOption
            invertColors={isFixedActive || showCTAButton}
            onActiveChangeState={setActiveSearch}
          />
          {!activeSearch && (
            <DrawerNavigation
              aria-label="Menu"
              aria-labelledby="Menu"
              onClose={() => setOpenDrawer(false)}
              onOpen={() => {}}
              onClickButton={() => setOpenDrawer(true)}
              open={openDrawer}
              iconColor={isFixedActive || showCTAButton ? "green3" : "white"}
              className="NavbarDrawerNavigation"
            >
              <div className={classNamesList("flex row p-6 center-content-h")}>
                <button
                  type="button"
                  aria-label="close"
                  className="momento-btn base menudrawer"
                  onClick={() => setOpenDrawer(false)}
                >
                  <img src="/images/close.svg" width="24px" height="24px" />
                </button>
              </div>
              <NavbarMenuMobile />
            </DrawerNavigation>
          )}
        </div>
      </div>

      <NavbarMenuDesktop />
    </nav>
  );

  if (showAll) {
    return (
      <>
        {!isMobile && mainNav}
        {breadcrumbNav}
      </>
    );
  }

  return showBreadcrumbs ? breadcrumbNav : mainNav;
};
